<div
  class="wrapper boundary"
  [ngClass]="{ side_menu_open: sideSectionService.sideContainerType !== sideContainerType.NONE }"
>
  <div class="social-modal" cdkDragBoundary=".boundary" cdkDrag>
    <div class="social-modal-title-container">
      @if (title) {
        <h2 class="social-modal-title">{{ title }}</h2>
      }

      @if (showContent) {
        <div class="close-button-container">
          <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="onCancel()"
            >close</mat-icon
          >
        </div>
      }
    </div>

    <mat-dialog-content class="social-modal-content">
      @if (warningMessage) {
        <span class="message bold">{{ warningMessage }}</span>
      }
      @if (message) {
        <span class="message"> {{ message }}</span>
      }
      @if (messageBold) {
        <span class="message">
          <b> {{ isPresenter ? 'Topic: ' : 'Question: ' }}</b> {{ messageBold }}</span
        >
      }
    </mat-dialog-content>

    @if (showContent) {
      <div class="social-modal-footer">
        @if (cancelButtonTitle) {
          <button
            data-testid="modal-cancel-button"
            mat-button
            class="social-modal-buttons button-margin"
            [ngClass]="isPresenter ? 'cancelButton' : 'social-modal-button-primary'"
            (click)="onCancel()"
          >
            {{ cancelButtonTitle }}
          </button>
        }
        @if (confirmButtonTitle) {
          <button
            data-testid="modal-confirm-button"
            mat-button
            class="social-modal-buttons social-modal-button-primary button-margin"
            (click)="onConfirm()"
          >
            {{ confirmButtonTitle }}
          </button>
        }
        @if (hideModalButtonTitle) {
          <button
            data-testid="hide-modal-button"
            mat-button
            class="social-modal-buttons social-modal-button-primary button-margin"
            (click)="onHideModal()"
          >
            {{ hideModalButtonTitle }}
          </button>
        }
      </div>
    }
  </div>
</div>
